import React, { memo, useEffect, useState } from 'react';
import ExperimentCanvas from 'components/plateviewer/experiment/ExperimentCanvas';
import {
  GetUnifiedExperimentCanvasWidth,
  GetUnifiedExperimentCanvasHeight,
  DisplayModes,
  SetDisplayMode,
  isNullOrUndefined,
  GetDefaultPlatePadding,
  SetPlatePadding,
  GetGlobalExpData,
  errorSrc,
  Create2DArray,
  customTabIconProps,
  SetExpRoute,
  ExperimentRoutes,
  GetDisplayMode,
} from 'utils/Global';
import 'components/customComponents/customTab.scss';
import './experiment.scss';

import { LayerDTO } from 'business/models/Models';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { selectGlobalDataLoaded } from 'redux/selectors/StateSelectors';
import { ELoadingTypes } from 'enums/ELoadingTypes';
import RMModal from 'components/modal/RMModal';
import ReactTooltip from 'react-tooltip';
import { CommandPanelsState } from 'business/models/CustomModels';
import { CustomTab } from 'components/customComponents/Renderer/ExperimentRouteRenderer';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { LoadingModal } from 'components/modal';
import { setPlateSize } from 'redux/reducers/experimentDataReducer';
import { ExperimentSideBarWidth } from 'components/Experiment/constants';

let plateWidth;
let plateHeight;
let experimentData: ExperimentDtoClient;
let recentExpID = 0;
const layerError = '';
let canvasHeight;
const ExpTabs = {
  Canvas: 'Canvas',
  Drop: 'Drop',
};

const selectedTab = ExpTabs.Canvas;
let widthMainDiv = 100;
let loadingDetails: string[] = [];
let gDataLoadingDisplayed = false;

interface Props {
  exp: ExperimentDtoClient;
  expId: number;
  paramsExpId: number;
  showLayers: boolean;
  reportType: string;
  panelsState: CommandPanelsState;
  isLayerMode: boolean;
  stateUpdated: boolean;
  showOptimize: boolean;
  widthMainDiv: number;
  openedSideBars: number;
  nodeMenuDetails: any;
  imageNowDetails: {};
  openedIconPanel: string;
  drawingLayerType: string;
  BottomMenu: JSX.Element;
  wellLables: any[];
  updateRoute(link: string): any;
  zoomInvocker(zoomIn: number): void;
  changeHeader: (name: string) => void;
  setReportType: React.Dispatch<React.SetStateAction<string>>;
  updateExpData(expData: any): void;
  isStateUpdated(): boolean;
  setScoreViewRef(scoreviewRefFromExp: any): Promise<void>;
  setShowOptimize: React.Dispatch<React.SetStateAction<boolean>>;
  setZoomInvocker(functionDelegate: any): void;
  getOrignalLayers(): LayerDTO[];
  changeShowLayers(open?: any): void;
  isExpDefinationChanged(): boolean;
  setIsScreenLoaded: (flag: boolean) => void;
  setSelectedSidePanelTab: any;
  setCanvasRefs?: any;
  canvasWidth: number;
}

const Screen = (props: Props) => {
  const [showLayerErrorModel, setShowLayerErrorModel] = useState(false);
  const dispatch = useRMDispatch();
  const expid: number = props.paramsExpId;
  const [refresh, setRefresh] = useState(false);
  const globaldataloaded = useRMSelector(selectGlobalDataLoaded);
  SetExpRoute(ExperimentRoutes.CANVAS);

  const [generateRequired, setGenerateRequired] = useState(false);

  useEffect(() => {
    loadingDetails = loadingDetails.filter((ld) => ld !== ELoadingTypes.Global);
    setRefresh(true);
  }, [globaldataloaded]);
  useEffect(() => {
    const updateFirstLoadDetails = async () => {
      SetDisplayMode(DisplayModes.DESIGN);
      if (isNullOrUndefined(GetGlobalExpData()) && !gDataLoadingDisplayed) {
        gDataLoadingDisplayed = true;
        loadingDetails.push(ELoadingTypes.Global);
        setRefresh(true);
      }
      const { exp }: { exp: ExperimentDtoClient } = props;
      if (exp === null || exp === undefined) {
        return null;
      }
      props.setScoreViewRef(setScoreView);
      props.changeHeader('showScreen');
      recentExpID = expid;
      experimentData = exp;
      if (experimentData === undefined) {
        return;
      }
      updatePlateSize();
      dispatch(setPlateSize({ plateWidth, plateHeight }));
      const wellinfo = Create2DArray(exp.colCount * exp.rowCount);
      if (exp.plateDto[0] === undefined) {
        return;
      }

      for (let plateNum = 0; plateNum < exp.colCount * exp.rowCount; plateNum++) {
        for (
          let wellNum = 0;
          wellNum < exp.plateDto[0].rows * exp.plateDto[0].cols;
          wellNum++
        ) {
          wellinfo[plateNum][wellNum] = null;
        }
      }

      ReactTooltip.hide();
      return exp;
    };

    if (recentExpID !== expid) {
      updateFirstLoadDetails();
    }
  }, [props.exp]);

  useEffect(() => {
    const updateExpDetails = () => {
      const { exp } = props;
      if (exp === null || exp === undefined) {
        return null;
      }
      experimentData = exp;
      setRefresh(true);
    };
    if (props.isStateUpdated()) {
      updateExpDetails();
    }

    props.changeHeader('showScreen');
  }, [props.stateUpdated]);

  const setScoreView = async () => {
    loadingDetails.push(ELoadingTypes.Loading);
    setRefresh(true);
    SetDisplayMode(DisplayModes.SCORE);
    loadingDetails = loadingDetails.filter((ld) => ld != ELoadingTypes.Loading);
    setRefresh(true);
  };

  const updatePlateSize = () => {
    const availableWidthPerPlate =
      GetUnifiedExperimentCanvasWidth(widthMainDiv) / experimentData.colCount;
    const availableHeightPerPlate =
      GetUnifiedExperimentCanvasHeight() / experimentData.rowCount;
    canvasHeight = GetUnifiedExperimentCanvasHeight();
    const paddedPlateWidth = availableWidthPerPlate - GetDefaultPlatePadding();
    const paddedPlateHeight = availableHeightPerPlate - GetDefaultPlatePadding();
    if (experimentData.colCount > experimentData.rowCount) {
      plateWidth = paddedPlateWidth;
      plateHeight =
        (paddedPlateWidth * experimentData.containerRows) / experimentData.containerCols;
    } else {
      plateHeight = paddedPlateHeight;
      plateWidth =
        (paddedPlateHeight / experimentData.containerRows) * experimentData.containerCols;
      plateHeight = paddedPlateHeight;
    }
    const wellRectWidth = plateWidth / experimentData.containerCols;
    SetPlatePadding(wellRectWidth + GetDefaultPlatePadding());
    plateWidth -= wellRectWidth;
    plateHeight -= wellRectWidth;
  };

  const calculateWidthWithCommandPanel = () => {
    if (props.openedSideBars === 1) {
      widthMainDiv = 68.816;
    } else if (props.openedSideBars > 1) {
      widthMainDiv = 60;
    }
  };
  const getMainTabContentWidth = () => {
    calculateWidthWithCommandPanel();
    return `${widthMainDiv.toString()}%`;
  };

  const getLoadingDetails = () => {
    const isSavingState = loadingDetails.find((ld) => ld === ELoadingTypes.Saving);
    if (!isNullOrUndefined(isSavingState)) {
      return ELoadingTypes.Saving;
    }
    if (loadingDetails.length > 0) {
      props.setIsScreenLoaded(false);
      return 'Loading...';
    } else {
      props.setIsScreenLoaded(true);
    }
  };

  function changeTabMode(tbMode) {
    if (tbMode === DisplayModes.IMAGE) {
      SetDisplayMode(DisplayModes.IMAGE);
      props.changeHeader('showImage');
    } else if (tbMode === DisplayModes.DESIGN) {
      SetDisplayMode(DisplayModes.DESIGN);
      props.changeHeader('showDesign');
    } else if (tbMode === DisplayModes.WELLINGREDIENT) {
      SetDisplayMode(DisplayModes.WELLINGREDIENT);
      props.changeHeader('showWellIngredients');
    }
  }

  function designTabRenderer() {
    return (
      <div id="screen-designtabrenderer-wrapper">
        <div
          id="screen-designtabrenderer-tabtrigger"
          onClick={() => changeTabMode(DisplayModes.DESIGN)}
        >
          <CustomTab
            Icon={
              <RMSvgIcon
                id="screen-svg-designtabrenderer-icon"
                name="Design"
                {...customTabIconProps}
              />
            }
            id={DisplayModes.DESIGN}
            active={GetDisplayMode()}
          />
        </div>
      </div>
    );
  }

  const ingredientTabRenderer = () => {
    return (
      <div
        id="screen-ingredienttabrenderer-tabtrigger"
        onClick={() => changeTabMode(DisplayModes.WELLINGREDIENT)}
      >
        <CustomTab
          Icon={
            <RMSvgIcon
              id="screen-svg-ingredienttabrenderer-icon"
              name="IngredientInfo"
              {...customTabIconProps}
            />
          }
          id={DisplayModes.WELLINGREDIENT}
          active={GetDisplayMode()}
        />
      </div>
    );
  };

  if (refresh) {
    setRefresh(false);
  }
  if (experimentData === null || experimentData === undefined) {
    return (
      <div
        id="screen-main-loading"
        style={{ display: 'flex', height: '100%', minWidth: '60%' }}
      >
        {' '}
        Loading Screen...
      </div>
    );
  }
  return (
    <div id="screen-main-container" className="expRouteMain">
      <RMModal
        id="screen-main-rmmodal"
        showModal={showLayerErrorModel}
        setShowModal={setShowLayerErrorModel}
        onOk={() => setShowLayerErrorModel(false)}
        body={layerError}
        heading="Cannot Save"
        okButtonText={'Ok'}
        noButtonText={'Cancel'}
        isOkOnly={true}
        icon={errorSrc}
        titleClr="red"
      />
      <div
        id="screen-main-tabparent"
        className={`expRouteTabParent w-[${ExperimentSideBarWidth}px]`}
      >
        {designTabRenderer()}
        {ingredientTabRenderer()}
      </div>
      <div
        id="screen-main-contentwrapper"
        className="flex flex-column content-width bg-light w100 h100"
      >
        <div id="screen-main-flexcontainer" className="flex  w100 h100">
          <div
            id="screen-main-canvascontainer"
            style={{
              minWidth: getMainTabContentWidth(),
              display: 'flex',
            }}
          >
            <LoadingModal
              showModal={loadingDetails.length !== 0}
              text={getLoadingDetails()}
            />
            <ExperimentCanvas
              expid={expid}
              widthMainDiv={props.widthMainDiv}
              selectedTab={selectedTab}
              loadingDetails={loadingDetails}
              canvasWidth={props.canvasWidth - ExperimentSideBarWidth}
              canvasHeight={canvasHeight}
              openedSideBars={props.openedSideBars}
              isLayerDrawingMode={props.isLayerMode}
              onSelectScreen={() => {}}
              onSelectProtein={() => {}}
              setZoomInvocker={props.setZoomInvocker}
              drawingLayerType={props.drawingLayerType}
              changeShowLayers={props.changeShowLayers}
              setRefresh={setRefresh}
              showOptimize={props.showOptimize}
              setShowOptimize={props.setShowOptimize}
              reportType={props.reportType}
              setReportType={props.setReportType}
              isScreenRoute={true}
              generateRequired={generateRequired}
              setGenerateRequired={setGenerateRequired}
              setSelectedSidePanelTab={props.setSelectedSidePanelTab}
              setCanvasRefs={props.setCanvasRefs}
            />
          </div>
        </div>
        <div id="screen-main-bottommenu">{props.BottomMenu}</div>
      </div>
    </div>
  );
};

export default memo(Screen);
